import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { GroupHive } from './group-hive.jsx';
import { ItemHive } from './item-hive.jsx';
import type { ContentProps, Hierarchy } from '../../types.js';

const toHierarchy = (data: ContentProps['data']): Hierarchy => {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  // Data should already be in Hierarchy format for Hive
  if (data.length > 0 && data[0] && 'rooms' in data[0] && Array.isArray(data[0].rooms)) {
    return data as Hierarchy;
  }

  return [];
};

/** Hive/PTZOptics vendor `<Content>` component with hierarchical organization/room structure. */
export const ContentHive = ({
  className,
  data,
  handler,
  hasRegistryLoaded: _hasRegistryLoaded,
  isRegistryLoading: _isRegistryLoading,
  orgOnly: _orgOnly,
  selectedOrgId: _selectedOrgId,
  selectedRoomId: _selectedRoomId,
  selection,
  ...props
}: ContentProps): ReactElement => {
  const hierarchy = toHierarchy(data);

  return (
    <div
      className={twMerge(
        'text-muted [&>div[role="menuitem"]]:text-md',
        'w-[100%] overflow-y-auto',
        className
      )}
      style={{ maxHeight: 'calc(100vh - 80px)' }}
      {...props}
    >
      {hierarchy.map(({ organization, rooms }) => (
        <GroupHive
          handler={handler}
          key={organization.id}
          organization={organization}
          rooms={rooms}
          selection={selection}
        />
      ))}

      {!!handler.onCreateAccount && (
        <ItemHive icon='plus' label='Create New Organization' onSelect={handler.onCreateAccount} />
      )}
    </div>
  );
};
